import styled from 'styled-components'

/**
 * Container do bloco de infos. Duas variantes:
 * - `flutuante`: barra sobre o mapa, ocupando a largura toda no topo.
 * - `sidebar`: header da sidebar de tela cheia, separado por borda.
 */
export const ContainerInfosMalha = styled.div<{ $variante: 'flutuante' | 'sidebar' }>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({ $variante }) =>
    $variante === 'flutuante'
      ? `
        position: absolute;
        top: 15px;
        right: 15px;
        left: 15px;
        width: auto;
        height: 50px;
        background-color: white;
        padding: 0 15px;
        border-radius: 8px;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
        z-index: 5;
      `
      : `
        padding: 15px;
        border-bottom: 1px solid #f0f0f0;
        flex-shrink: 0;
      `}
`

/**
 * Item de informação (rótulo + valor) do bloco de infos da malha.
 *
 * Estilo próprio em vez de herdar do container: antes o container estilizava `div { }`
 * de forma genérica e acabava pegando também a área de ações ao lado.
 *
 * `$destaque` pinta o valor com o laranja de aviso do projeto — usado no contador de
 * pontos sem análise, para que sobrar ponto salte à vista sem virar um alerta bloqueante.
 */
export const ItemInfoMalha = styled.div<{ $destaque?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  label {
    font-size: 11px;
    font-weight: 500;
    color: #7b7b7b;
    padding: 0;
    margin: 0;
  }

  p {
    padding: 0;
    margin: 0;
    line-height: 1.1;
    font-size: 13px;
    font-weight: 600;
    ${({ $destaque }) => $destaque && `color: #ef7918;`}
  }
`
